export default {
    data: [
        'chủ doanh nghiệp',
        'chủ hộ kinh doanh',
        'ban lãnh đạo',
        'quản lý trung gian',
        'nhân viên thường',
        'cơ quan quản lý nhà nước',
        'công an - quân đội',
        'làm nghề tự do',
        'ngân hàng',
        'tiệm vàng',
        'cầm đồ / tín chấp',
        'bảo hiểm',
        'bất động sản',
        'xe máy/oto',
        'bán hàng',
        'kế toán',
        'marketing/QC',
        'công nghệ thông tin',
        'tư vấn luật',
        'chứng khoán',
        'giảng viên',
        'cửa hàng đồ uống',
        'quán ăn',
        'nhà hàng / tiệc cưới',
        'khách sạn',
        'du lịch',
        'phòng gym/spa',
        'karaoke / dv giải trí',
        'giáo dục đào tạo',
        'y tế / bệnh viện',
        'tiệm tạp hóa',
        'hoạt động nghệ thuật',
        'nơi vui chơi giải trí',
        'sản xuất nông nghiệp',
        'kinh doanh nông nghiệp',
        'vât tư nông nghiệp',
        'chăn nuôi',
        'kinh doanh gia súc gia cầm',
        'thủy hải sản + KD hải sản',
        'lâm nghiệp + KD lâm nghiệp',
        'kinh doanh thực phẩm chế biến',
        'trang phục cá nhân',
        'đồ gia dụng',
        'thiết bị viễn thông',
        'thiết bị văn phòng',
        'phụ tùng các loại',
        'in ấn / quảng cáo',
        'kiến trúc / thiết kế',
        'xây dựng dân dụng',
        'xây dựng công trình nhà nước',
        'vật liệu xây dựng',
        'vận tải hành khách',
        'vận tải hàng hóa',
        'kho bãi / logictis',
        'phân phối hàng tiêu dùng nhanh',
        'may mặc',
        'khai khoáng',
        'công nghiệp thực phẩm',
        'công nghiệp đồ uống',
        'công nghiệp nhẹ',
        'công nghiệp nặng',
    ]
}